"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    list: function list(_ref2) {
      var underline = _ref2.underline;
      var p = underline ? undefined : 0;
      return {
        color: palette.text.primary,
        paddingBottom: p,
        paddingTop: p,
        '&:not(:last-of-type)': {
          borderBottom: "1px solid ".concat(underline ? palette.text.primary : 'transparent')
        }
      };
    },
    listButton: {
      cursor: 'pointer'
    },
    nestedItems: {
      paddingLeft: '.5rem',
      cursor: 'pointer'
    },
    heading: {
      fontSize: '1rem',
      margin: 0,
      lineHeight: 3
    }
  };
});
var _default = useStyles;
exports["default"] = _default;